import { makeStyles } from 'tss-react/mui'
import { nunito_sans } from '@styles/fonts'

const useStyles = makeStyles()((theme) => ({
  root: {
    padding: theme.spacing(10, 0, 20),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 0, 15),
    },
    table: {
      width: '100%',
    },
  },

  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    img: {
      height: '80px',
    },

    '@media (max-width:1150px)': {
      img: {
        height: '42px',
        padding: theme.spacing(2, 0),
      },
    },
    '@media (max-width:840px)': {
      img: {
        height: '35px',
        padding: theme.spacing(1, 0),
      },
    },
    '@media (max-width:680px)': {
      img: {
        height: '26px',
        padding: theme.spacing(1, 0),
      },
    },
  },

  outerContainer: {
    height: 'auto',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
  },

  campaignsContainer: {
    padding: theme.spacing(0, 16),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 4),
    },
  },
  headline: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '48px',
    lineHeight: '83px',
    textTransform: 'uppercase',
    color: '#FFFFFF',
    whiteSpace: 'nowrap',
    margin: '2rem',
    [theme.breakpoints.down('md')]: {
      fontSize: '30px',
      marginTop: '0',
      margin: '1.5rem',
    },
    '@media (max-width:400px)': {
      fontSize: '25px',
      marginTop: '0',
      margin: '1.5rem',
    },
  },
  emptyLi: {
    marginLeft: '.7rem',
  },

  headlineWrapper: {
    display: 'flex',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    justifyContent: 'center',

    li: {
      animation: 'marquee 6s linear infinite',
      '@keyframes marquee': {
        '0%': {
          transform: 'translateX(0%)',
        },
        '100%': {
          transform: 'translateX(-100%)',
        },
      },
    },

    margin: 'auto',
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      fontSize: '30px',
      paddingBottom: theme.spacing(0),
    },
  },
  zenColor: {
    color: theme.custom.blackColor,
  },

  cell: {
    borderCollapse: 'collapse',
    border: '1px solid',
    width: '100%',
    padding: theme.spacing(1, 0, 0),
  },

  outerCell: {
    padding: theme.spacing(8, 10),
    border: '1px solid',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(6, 8),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4, 6),
    },
  },
  table: {
    width: '100%',
    maxWidth: theme.maxWidth,
    borderCollapse: 'collapse',
    borderStyle: 'hidden',

    tbody: {
      width: '100%',
    },
    tr: {
      whiteSpace: 'nowrap',
      width: '100%',
      td: {
        width: '700px',

        [theme.breakpoints.down('md')]: {
          width: '200px',
        },
        [theme.breakpoints.down('sm')]: {
          width: '100px',
        },
      },
    },
  },
}))

export default useStyles
